var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCertificationServiceBodyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 189,
    viewBox: "0 0 171 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2025_300)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6621 33.034L30.3417 68.574C32.03 72.9601 36.3659 75.7464 41.0569 75.4596L57.8797 74.4312L65.4612 93.6766L99.9346 88.3319L74.758 39.87L74.3383 40.5512L61.4679 15.5674L16.6621 33.034Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.482 102.944C141.738 90.5184 130.293 82.0146 117.316 82.0146H20.1311C10.2704 82.0146 3.20255 91.5266 6.04785 100.968L28.6715 176.037C30.5438 182.25 36.266 186.502 42.7547 186.502H150.869C160.73 186.502 167.797 176.99 164.952 167.548L145.482 102.944Z",
    fill: "#2B374E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7182 178.625L56.7497 168.409C59.6336 166.776 62.9623 166.101 66.2547 166.483L96.1791 169.955L96.1791 180.606L88.9387 179.776L80.946 180.988C75.1129 181.872 69.1486 181.087 63.7427 178.724L61.2631 177.64C59.1916 176.735 56.859 176.625 54.7112 177.33L41.5488 181.656C40.7133 181.93 39.8104 181.92 38.9814 181.626C37.6436 181.152 37.4834 179.325 38.7182 178.625Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.716 83.681L35.8717 76.5432C33.0431 75.4118 30.7534 73.2429 29.4705 70.4797L25.8347 62.6486C25.3988 61.7099 24.5953 60.9923 23.6134 60.665C21.6795 60.0204 19.7606 61.6808 20.1208 63.6872L21.7819 72.9423C22.3806 76.2779 24.3673 79.2024 27.2475 80.9882L43.6267 91.1433C45.7884 92.4836 47.2983 94.6595 47.7971 97.1536L50.4162 110.249H65.4776L62.1058 93.7269C61.1778 89.1798 58.0249 85.4045 53.716 83.681Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7413 42.1074L30.8967 47.1367",
    stroke: "black",
    strokeWidth: 2.87386,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7413 42.1074L30.8967 47.1367",
    stroke: "black",
    strokeWidth: 2.87386,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7413 42.1074L30.8967 47.1367",
    stroke: "black",
    strokeWidth: 2.87386,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5472 37.0781L46.7026 42.1074",
    stroke: "black",
    strokeWidth: 2.87386,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5472 37.0781L46.7026 42.1074",
    stroke: "black",
    strokeWidth: 2.87386,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5472 37.0781L46.7026 42.1074",
    stroke: "black",
    strokeWidth: 2.87386,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.36 43.2869L75.5194 40.0959L65.1813 11.964C62.7429 5.3286 55.4283 1.88074 48.7583 4.22273L20.9508 13.9865C15.116 16.0352 12.1983 22.5631 14.5636 28.2769L16.9792 34.1123L48.1391 23.0681L53.4962 34.9333L56.4042 34.1123C56.0059 32.5168 56.3245 28.8471 60.7847 26.9327C68.1122 24.0607 67.5547 36.6389 66.36 43.2869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.003 41.9466C109.052 35.8565 110.673 33.941 113.62 32.1238C115.732 30.7486 117.353 29.2261 117.353 26.9669C117.353 24.5112 115.437 22.8904 113.08 22.8904C110.771 22.8904 108.66 24.4129 108.561 27.3107H101.587C101.734 20.3856 106.842 17.095 113.129 17.095C119.956 17.095 124.818 20.6803 124.818 26.7213C124.818 30.7486 122.755 33.3517 119.514 35.2671C116.763 36.937 115.535 38.5086 115.486 41.9466V42.4868H109.003V41.9466ZM112.392 53.5866C110.084 53.5866 108.218 51.7202 108.267 49.461C108.218 47.2018 110.084 45.3845 112.392 45.3845C114.553 45.3845 116.469 47.2018 116.469 49.461C116.469 51.7202 114.553 53.5866 112.392 53.5866Z",
    fill: "#3A7EFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2025_300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170.328,
    height: 188.387,
    fill: "white",
    transform: "translate(0.335938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertificationServiceBodyMobile);
export default __webpack_public_path__ + "static/media/IcCertificationServiceBodyMobile.9c8426537ddb864181f95742cec7219a.svg";
export { ForwardRef as ReactComponent };